import { Api } from "@/services/Api";
import store from "../store";

export default {
  reviewBooking(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("booking/review", data, {
      headers
    });
  },
  addBooking(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("booking/add", data, {
      headers
    });
  },
  viewPayment(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("payments/view-payment", data, {
      headers
    });
  },
  viewRecurringPayment(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("payments/view-recurring-payment", data, {
      headers
    });
  },
  getBooking(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("booking/list", data, {
      headers
    });
  },
  viewBooking(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("booking/view", data, {
      headers
    });
  },
  stripePayment(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("payments/stripe", data, {
      headers
    });
  },
  stripeRecurringPayment(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("payments/stripe-recurring", data, {
      headers
    });
  },
  checkBooking(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("availability/check", data, {
      headers
    });
  },
  getAvailability(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("availability/list", data, {
      headers
    });
  },
  getOnlyAvailable(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("availability/list/available", data, {
      headers
    });
  },
  addBulkBooking(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("availability/add/bulk", data, {
      headers
    });
  },
  addAvailability(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("availability/add", data, {
      headers
    });
  },
  removeAvailability(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("availability/remove", data, {
      headers
    });
  },
  cancelBooking(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("booking/cancel", data, {
      headers
    });
  },
  changeBooking(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("booking/change", data, {
      headers
    });
  }
};
